import { useEffect, useState } from 'react'
import { sessionStorageHelper } from '@utils/localStorageHelper'

interface PaginationHistoryParams {
  id?: string
  collectionName?: string | string[]
  locale?: string
  queryString: string
  pageIdentifier?: string | string[] | null
}
export const usePaginationHistory = ({
  id,
  collectionName,
  locale,
  queryString,
  pageIdentifier,
}: PaginationHistoryParams) => {
  const [pageState, setPageState] = useState(parseFloat('1'))
  const [activePages, setActivePages] = useState(1)
  const [lastCategory, setLastCategory] = useState(pageIdentifier)

  useEffect(() => {
    if (!pageIdentifier) return
    const savedPage = parseInt(sessionStorageHelper.get('categoryPage') || '1')
    const savedActivePages = parseInt(sessionStorageHelper.get('categoryActivePages') || '1')
    const savedLastPage = sessionStorageHelper.get('lastCategoryPages') || ''

    if (!isNaN(savedPage)) setPageState(savedPage)
    if (!isNaN(savedActivePages)) setActivePages(savedActivePages)
    if (savedLastPage) {
      setLastCategory(savedLastPage)
    }
  }, [])

  useEffect(() => {
    if (!pageIdentifier) {
      sessionStorageHelper.set('categoryPage', pageState.toString())
      sessionStorageHelper.set('categoryActivePages', activePages.toString())
    }
  }, [pageState, activePages])

  useEffect(() => {
    if (!pageIdentifier) return
    sessionStorageHelper.set('lastCategoryPages', pageIdentifier)
  }, [pageIdentifier])

  return {
    pageState,
    setPageState,
    activePages,
    setActivePages,
    lastCategory,
  }
}
